import React, { useRef } from "react";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import { MainText, PressableOpacity } from "app/components/common";
import normalize from "app/utils/normalize";
import { isWeb, isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { TextInput } from "react-native";
import WenIcon from "../../components/Icons/Search/WenIcon";

interface IProps {
  testID: String;
  boxStyle: {};
  onPress: () => void;
  onClickOutside: () => void;
  hasClearButton?: boolean;
}

const SearchButton = ({
  onPress,
  onClickOutside,
  boxStyle,
  testID,
  hasClearButton = true,
  ...props
}: IProps) => {
  return (
    <PressableOpacity
      testID={testID}
      onPress={onPress}
      style={[styles.box, boxStyle]}
    >
      <WenIcon
        height={normalize(20)}
        width={normalize(20)}
        color={theme.colors["neutral.500"]}
      />
      <MainText
        selectable={false}
        variant="l4-medium"
        color="neutral.600"
        testID="search-input"
        zIndex={1}
        paddingHorizontal="xs"
        lineHeight={0}
        height="100%"
        outline="transparent"
      >
        {i18n.t("search-placeholder")}
      </MainText>
    </PressableOpacity>
  );
};

const styles = {
  box: {
    zIndex: 2,
    backgroundColor: theme.colors["neutral.50"],
    borderWidth: 1,
    borderColor: theme.colors["neutral.100"],
    padding: normalize(10),
    paddingLeft: normalize(15),
    borderRadius: normalize(200),
    width: isWebDesktop ? "100%" : wp("90%"),
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
};

export default SearchButton;
